(function () {
  var initializedTracks = new WeakSet();

  function getSlideWidth(track) {
    var slide = track.children[0];
    return slide ? slide.getBoundingClientRect().width : 0;
  }

  function setPosition(track, index, animate) {
    var width = getSlideWidth(track);

    if (!animate) {
      track.style.transition = 'none';
    }

    track.style.transform = 'translateX(-' + (width * index) + 'px)';
    track.dataset.currentIndex = index;

    if (!animate) {
      // Forzamos un reflow para que el navegador aplique la posición
      // sin transición ANTES de volver a habilitarla.
      // eslint-disable-next-line no-unused-expressions
      track.offsetHeight;
      track.style.transition = '';
    }
  }

  function initTrack(track) {
    if (initializedTracks.has(track)) return;

    var slides = Array.prototype.slice.call(track.children);
    if (slides.length < 2) return;

    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[slides.length - 1].cloneNode(true);
    firstClone.classList.add('is-clone');
    lastClone.classList.add('is-clone');

    track.appendChild(firstClone);
    track.insertBefore(lastClone, slides[0]);

    initializedTracks.add(track);
    track.dataset.animating = 'false';

    // El índice 1 apunta al primer slide real (índice 0 es el clon del último).
    setPosition(track, 1, false);
  }

  function handleTransitionEnd(event) {
    if (event.propertyName && event.propertyName !== 'transform') return;

    var track = event.target;
    if (!track.classList || !track.classList.contains('grid-product__carousel-track')) return;

    var slides = track.children;
    var lastRealIndex = slides.length - 2;
    var currentIndex = parseInt(track.dataset.currentIndex, 10);

    if (currentIndex === slides.length - 1) {
      // Llegamos al clon de la primera foto al final -> saltamos sin animar a la real.
      setPosition(track, 1, false);
    } else if (currentIndex === 0) {
      // Llegamos al clon de la última foto al inicio -> saltamos sin animar a la real.
      setPosition(track, lastRealIndex, false);
    }

    // Ya terminó de moverse (incluyendo el posible salto de clon a real):
    // recién ahora permitimos el siguiente clic.
    track.dataset.animating = 'false';
  }

  function handleClick(event) {
    var arrow = event.target.closest('.grid-product__carousel-arrow');
    if (!arrow) return;

    event.preventDefault();
    event.stopPropagation();

    var productId = arrow.dataset.productCarouselNav;
    var direction = arrow.dataset.direction;
    if (!productId) return;

    var track = document.querySelector('[data-carousel-track="' + productId + '"]');
    if (!track) return;

    initTrack(track);

    // Si todavía está animando el clic anterior, ignoramos este clic
    // para que el índice nunca se adelante más de un paso por vez.
    if (track.dataset.animating === 'true') return;

    var currentIndex = parseInt(track.dataset.currentIndex || '1', 10);
    var newIndex = direction === 'next' ? currentIndex + 1 : currentIndex - 1;

    track.dataset.animating = 'true';
    setPosition(track, newIndex, true);
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('transitionend', handleTransitionEnd);

  document.querySelectorAll('.grid-product__carousel-track').forEach(function (track) {
    initTrack(track);
  });

  // Los tracks que nacen dentro de un contenedor oculto (display: none, como
  // una pestaña inactiva) miden su ancho en 0 al inicializarse. Esta función
  // permite recalcular su posición real una vez que se vuelven visibles.
  window.refreshCarouselPositions = function (root) {
    var scope = root || document;
    var tracks = scope.classList && scope.classList.contains('grid-product__carousel-track')
      ? [scope]
      : scope.querySelectorAll('.grid-product__carousel-track');

    Array.prototype.forEach.call(tracks, function (track) {
      if (!initializedTracks.has(track)) {
        initTrack(track);
        return;
      }

      var index = parseInt(track.dataset.currentIndex || '1', 10);
      setPosition(track, index, false);
    });
  };
})();